export type HistoryShortcut = 'undo' | 'redo'

export const isTypingTarget = (target: EventTarget | null): boolean => {
  if (typeof globalThis.HTMLElement !== 'function' || !(target instanceof globalThis.HTMLElement)) return false
  return target.closest('input, textarea, select') != null || target.isContentEditable
}

export const shortcutLetter = (e: Pick<KeyboardEvent, 'key' | 'code'>): string | null => {
  if (/^[a-z]$/i.test(e.key)) return e.key.toLowerCase()
  const physical = /^Key([A-Z])$/.exec(e.code)
  return physical != null ? physical[1].toLowerCase() : null
}

export const historyShortcutOf = (
  e: Pick<KeyboardEvent, 'key' | 'code' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'isComposing' | 'defaultPrevented'>
): HistoryShortcut | null => {
  if (e.defaultPrevented || e.isComposing || e.altKey) return null
  if (!e.metaKey && !e.ctrlKey) return null
  const letter = shortcutLetter(e)
  if (letter === 'z') return e.shiftKey ? 'redo' : 'undo'
  if (letter === 'y' && e.ctrlKey && !e.metaKey && !e.shiftKey) return 'redo'
  return null
}

export const isMacPlatform = (nav: Pick<Navigator, 'platform' | 'userAgent'> | undefined = globalThis.navigator): boolean => {
  if (nav == null) return false
  const source = nav.platform !== '' ? nav.platform : nav.userAgent
  return /mac|iphone|ipad|ipod/i.test(source)
}

export const undoShortcutHint = (mac: boolean): string => mac ? '⌘Z' : 'Ctrl+Z'
export const redoShortcutHint = (mac: boolean): string => mac ? '⇧⌘Z' : 'Ctrl+Y'
